import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import * as R from 'ramda';
import PageLoader from '../../../../../components/PageLoader';
import { accounts } from '../../../../../redux/accounts/action';
import { selectAccountTypesListItems } from '../../../../../redux/account-types/selector';
import { toast } from 'react-toastify';
import { agents } from '../../../../../redux/agents/action';
import { selectAgentsListItems } from '../../../../../redux/agents/selector';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import TransporterComponent from '../components/transporter.component';
import { selectListItems } from '../../../../../redux/library/selector';
import { selectTransportersQueryItems } from '../../../../../redux/transporters/selector';
import { selectStoresListItems } from '../../../../../redux/stores/selector';
import { stores } from '../../../../../redux/stores/action';
import { transporters } from '../../../../../redux/transporters/action';

const ManagementTransporter = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const libraryData = useSelector(selectListItems)
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const accountItems = useSelector(selectAccountsListItems)
    const transportAgentItems = useSelector(selectAgentsListItems)
    const TransportersQuery = useSelector(selectTransportersQueryItems)
    const storeItems = useSelector(selectStoresListItems)

    const [
        selectedTransporters,
        setSelectedTransporters
    ] = useState<any>({})

    const [
        selectedAccounts,
        setSelectedAccounts
    ] = useState<any>({
        LoginInfo: {},
        UserInfo: {},
        AccountInfo: {
            IsPersonAccount: true,
            IsCustomerPortalEnabled: false,
            IsVendorPortalEnabled: false,
            IsPartnerEnabled: false,
            IsAccountVerified: true,
            IsGuestAccessEnabled: true,
            IsLimitedToOrganizationUnit: false,
            EnableOnNetworkLogisticsSupport: true,
            MappedAccountTypes: {}
        },
        AccountAddress: {},
        PrimaryAddress: {}

    })
    const fetchTransportersQueryById = () => {
        dispatch(transporters.query({
            url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/raps/query`, entity: 'transporters', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })

    }

    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
            '.',
            field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedAccounts({ ...selectedAccounts, [fields[0]]: value });
        setSelectedTransporters({ ...selectedTransporters, [fields[0]]: value });
    }
    const handleBasicInnerFormChange: any = (event: any, field: string) => {
        setSelectedTransporters({ ...selectedTransporters, [field]: event });
    }

    useEffect(
        () => {
            dispatch(accounts.list({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`, entity: 'accounts', jsonData: {}
            }))

                .then(() => {
                    dispatch(stores.list({
                        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`, entity: 'stores', jsonData: {}
                    }))
                }).then(() => {
                    dispatch(agents.list({
                        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/agents/list`, entity: 'agents', jsonData: {

                        }
                    }))
                }).then(() => {
                    if (parmas?.id > 0) {
                        fetchTransportersQueryById()
                        setIsLoading(false)
                    } else {
                        setIsLoading(false)
                    }
                })
        },
        []
    )

    useEffect(
        () => {

            if (isQuery) {
                setSelectedTransporters({
                    Id: TransportersQuery?.result?.items?.Id,
                    UserProfile: TransportersQuery?.result?.items?.UserProfile,
                    IsDeliveryHubEnabled: TransportersQuery?.result?.items?.IsDeliveryHubEnabled,
                    Login: TransportersQuery?.result?.items?.Login,
                    Account: TransportersQuery?.result?.items?.Account,
                    MappedAgents: TransportersQuery?.result?.items?.MappedAgents,
                    Address: TransportersQuery?.result?.items?.Address,
                    GSTInfo: TransportersQuery?.result?.items?.TaxInfo?.GSTInfo,
                    RAPInfo: TransportersQuery?.result?.items?.RAPInfo
                })

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        if (parmas?.id > 0) {
            dispatch(transporters.update({
                url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/raps`, entity: 'transporters', jsonData: {

                    Records: [
                        {
                            Id: selectedTransporters?.Id,
                            Login: selectedTransporters?.Login,
                            UserProfile: selectedTransporters?.UserProfile,
                            RAPInfo: selectedTransporters?.RAPInfo,
                            Account: selectedTransporters?.Account,
                            Address: selectedTransporters?.Address,
                            TaxInfo: {
                                GSTInfo: selectedTransporters?.GSTInfo
                            },
                            MappedAgents: selectedTransporters?.MappedAgents?.AgentIds,
                            IsDeliveryHubEnabled: selectedTransporters?.IsDeliveryHubEnabled
                        }

                    ]
                }
            })).then(() => {
                back()
            })

        } else if (selectedAccounts?.LoginInfo?.Password === selectedAccounts?.LoginInfo?.ConfirmPassword) {
            selectedAccounts.UserInfo.Salutation = 0
            let accountTypes = _.find(accountTypeItems.result.items, ['Name', 'RAP']);
            selectedAccounts.AccountInfo.Name = `${selectedAccounts?.UserInfo?.FirstName} ${selectedAccounts?.UserInfo?.LastName}`
            selectedAccounts.AccountInfo.TypeId = 250 //accountTypes.Id
            selectedAccounts.AccountInfo.IsPersonAccount = false
            selectedAccounts.AccountInfo.MappedAccountTypes.MappedAccountTypeIds = [accountTypes.Id]
            selectedAccounts.AccountAddress.PrimaryAddress = selectedAccounts?.PrimaryAddress
            selectedAccounts.AccountAddress.PrimaryAddress.FaxNumber = selectedAccounts?.LoginInfo.PhoneNumber
            selectedAccounts.AccountAddress.PrimaryAddress.GeocodeAccuracy = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.Latitude = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.Longitude = 0,
                selectedAccounts.AccountAddress.PrimaryAddress.OpeningHoursTypeId = 30,
                selectedAccounts.AccountAddress.IsUsePrimaryAddressAsBillingAddress = true
            selectedAccounts.AccountAddress.IsUsePrimaryAddressAsShippingAddress = true
            selectedAccounts.AccountAddress.BillingAddress = {}
            selectedAccounts.AccountAddress.ShippingAddress = {}
            const data = _.omit(selectedAccounts, 'PrimaryAddress');

            dispatch(accounts.create({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts`, entity: 'accounts', jsonData: {

                    Records: [
                        {
                            Context: {},
                            Message: data

                        }
                    ]

                }
            })).then(() => {
                back()
            })
        } else {
            toast.error("Password and Confirm Password must be same.")
        }

    }

    const back = () => {
        navigate('/management/rap-manager/raps')
    }


    return (
        <>
            {isLoading ? <PageLoader /> :
                <TransporterComponent
                    id={parmas?.id}
                    selectedAccounts={selectedAccounts}
                    handleInnerFormChange={handleInnerFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    accounts={accountItems?.result?.items}
                    agents={transportAgentItems?.result?.items}
                    GSTType={libraryData?.result?.GSTType}
                    GSTRegistrationType={libraryData?.result?.GSTRegistrationType}
                    stores={storeItems?.result?.items}
                    handleBasicInnerFormChange={handleBasicInnerFormChange}
                    selectedTransporters={selectedTransporters}
                />
            }

        </>
    )

}

export default ManagementTransporter;